require('./object.assign');
require('./string.includes');


// WEBPACK FOOTER //
// ./src/polyfill/index.js